var lib_core = require("lib-core");
var HeaderStraightData = require("./headerStraightData.js");

var HeaderStraightSocketData = function(position, angle, init) {
    HeaderStraightData.apply(this, arguments);
};

lib_core.inherit(HeaderStraightSocketData, HeaderStraightData);
lib_core.JsonParser.registerClass(HeaderStraightSocketData, "HeaderStraightSocketData");
module.exports = HeaderStraightSocketData;